import type { Size } from "@embedpdf/models";

const PDF_POINT_DPI = 72;
const PRINT_DPI = 300;

// A smaller box makes the signature API fail: pyHanko truncates its size to whole points.
export const MIN_SIGNATURE_SIZE_POINTS = 1;
export const MIN_PREPOSITION_PIXELS = Math.ceil((MIN_SIGNATURE_SIZE_POINTS * PRINT_DPI) / PDF_POINT_DPI);

// We assume users are giving signature dimensions based on printed/scanned source,
// so using standard print DPI
export function pxToPdfPoints(valueAtPrintDPI: number | undefined): number | undefined {
  return valueAtPrintDPI && (valueAtPrintDPI * PDF_POINT_DPI) / PRINT_DPI;
}

export function enforceMinimumSize({ width, height }: Size): Size {
  return { width: atLeastMinimum(width), height: atLeastMinimum(height) };
}

export function scaleUpToMinimumSize({ width, height }: Size): Size {
  if (!isPositiveFinite(width) || !isPositiveFinite(height)) {
    return { width: MIN_SIGNATURE_SIZE_POINTS, height: MIN_SIGNATURE_SIZE_POINTS };
  }
  const factor = Math.max(1, MIN_SIGNATURE_SIZE_POINTS / Math.min(width, height));
  return { width: width * factor, height: height * factor };
}

export function ignoreBelowMinimum(points: number | undefined): number | undefined {
  return points !== undefined && points >= MIN_SIGNATURE_SIZE_POINTS ? points : undefined;
}

function atLeastMinimum(points: number): number {
  return Number.isFinite(points) ? Math.max(MIN_SIGNATURE_SIZE_POINTS, points) : MIN_SIGNATURE_SIZE_POINTS;
}

function isPositiveFinite(value: number): boolean {
  return Number.isFinite(value) && value > 0;
}
